import { render } from "./ValoracionNumerica.vue?vue&type=template&id=21e6d50a"
import script from "./ValoracionNumerica.vue?vue&type=script&lang=js"
export * from "./ValoracionNumerica.vue?vue&type=script&lang=js"

import "./ValoracionNumerica.vue?vue&type=style&index=0&id=21e6d50a&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__